(function () {
    'use strict';

    angular.module("imApp").factory("poFinishListService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3477,
                    parameters: parms || {}
                });
            },
            listPoFinishes: function (parms) {
                return $ihttp.post({
                    method: 179,
                    parameters: parms || {}
                });
            },
            deleteItems: function (list) {
                return $ihttp.post({
                    method: 214,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
